var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m422 0h-422v452c0 33.085938 26.914062 60 60 60h392 .007812c33.078126 0 59.992188-26.914062 59.992188-60v-211h-90zm-362 482c-16.542969 0-30-13.457031-30-30v-422h362v422c0 10.925781 2.949219 21.167969 8.070312 30zm422-211v181c0 16.542969-13.453125 30-30 30-16.542969 0-30-13.457031-30-30v-181zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60 181h302v-121h-302zm30-91h242v61h-242zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m60 211h151v30h-151zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m241 211h121v30h-121zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m60 271h151v30h-151zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    sd: "m241 271h121v30h-121zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m60 331h151v30h-151zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m60 391h151v30h-151zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m241 421h121v-90h-121zm30-60h61v30h-61zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.a6ab828f99d65739a019b661791c461e.svg";
export { ForwardRef as ReactComponent };